import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { Overlay, Toast, Popup, Picker } from 'vant'

// less
import 'swiper/css/swiper.min.css'
import './assets/less/main.less'

Vue.config.productionTip = false

Vue.use(Overlay)
  .use(Toast)
  .use(Popup)
  .use(Picker)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
